import { decodePublicId } from '@/services/api/resources/public-ids/actions';
import { taskToPromise } from '@/ui/helpers/fpTsHelper';
import { NavigationGuardNext, Route } from 'vue-router';

/**
 * In order to use this guard you must create a pair of routes with the same name, one for the encoded id and one for the decoded id.
 * The route for the encoded id must have the name of the route for the decoded id with the word "Public" appended at the end.
 * E.g. "myRoute" and "myRoutePublic".
 */
export const guardRedirectEncodedId = async (
  to: Route,
  from: Route,
  next: NavigationGuardNext,
): Promise<void> => {
  const response = await taskToPromise(decodePublicId, to.params.id);
  const newRoute = to.name!.replace(/Public$/, '');

  next({ name: newRoute, params: { id: String(response.id) } });
};
